import '../css/banner.css';

const Banner = ({ title, backgroundImage, breadcrumb }) => {
  const bg = `url('${backgroundImage}')`;
  return (
    <section className="banner-section-sub-page" style={{ backgroundImage: bg, position: 'relative' }}>
      <div className="container banner-content">
        <h3 className="banner-title text-white">{title}</h3>
        {breadcrumb && <nav aria-label="breadcrumb">{breadcrumb}</nav>}
      </div>
    </section>
  );
};

export default Banner;